import React from "react";
import "../../assets/img/Logo.png"
import "./NavBar.scss"

class NavBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = { windowWidth: window.innerWidth };
    }

    scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop - 100) 

    handleResize = (e) => {
        this.setState({ windowWidth: window.innerWidth });
    };
      
    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
    }
    
	img() {
		return (
			<img className="logoSrc" src={require("assets/img/Logo.png")} />
            );
    }
    
    nav(){
        return(
            <div className="navBar">
                <div onClick={()=>this.scrollToRef(this.props.refList.summary)}>Project Description</div>
                <div onClick={()=>this.scrollToRef(this.props.refList.team)}>Team</div>
                <div onClick={()=>this.scrollToRef(this.props.refList.team)}>Museum Partnership</div>
                <div onClick={()=>this.scrollToRef(this.props.refList.team)}>Design</div>
                <div onClick={()=>this.scrollToRef(this.props.refList.sponsors)}>Sponsors</div>

            </div>
        )
    }

	render() {
		return (
			<div className="navBarSection">
                <div className="navBarWrapper">
                    {this.img()}
                    {this.nav()}
                </div>
            </div>
		);
	}
}
export default NavBar;
